define('model/template.preview.model',['require','exports','module','formkit/formkit'],function(require, exports, module) {
  var FormKit = require('formkit/formkit');

  var TemplatePreviewModel = FormKit.TemplateModel.extend({
    urlRoot: '/api/v1/document-state/preview',
  });

  module.exports = TemplatePreviewModel;
});

